import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_TYPE, MSG, SYSTEM_PATH } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import yup from '../../core/utils/yupValidate';
import { useState, useEffect } from 'react';

function ForgotPasswordScreen() {
    const navigate = useNavigate();
    const location = useLocation();
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    const validateLoginSchema = yup.object().shape({
        email: yup.string().required('メールアドレスを入力する必要があります。')
    });
    
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting }
    } = useForm({ resolver: yupResolver(validateLoginSchema), mode: 'onChange' });
    

    // store
    const {
        modalStore: { openAlert , hide},
        passwordStore: { forgetPassword }
    } = useStore();

    const handleForgetPassword = (payload) => {
        forgetPassword({
            ...payload,
            role: location?.state?.loginType ?? LOGIN_TYPE.STUDENT
        }, () => {
            openAlert(MSG['confirm.student.send.email'], ()=> {
                navigate(SYSTEM_PATH.LOGIN);
                hide();
            })
        });
    };

    const navigateInquire = (payload) => {
        navigate(SYSTEM_PATH.SEND_INQUIRY,{ state: { isForgotPassword : true }})
    }

    return (
        <div id="main" className="wrapper main-signin main-Forgot-Password">
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className="container">
                    <ul>
                        <li  >
                            <a href={SYSTEM_PATH.HOME}>
                                <img src="/images/icon-home.png" alt="" />
                            </a>
                        </li>
                        <li className="dash">\</li>
                        <li>パスワード再発行</li>
                    </ul>
                </div>
            </div>
            {/* <a className='hover-link'>ログインできない方はこちら</a> */}

            <div className="content-signin">
                <div className="container">
                    <div className="content-form">
                        <h2 className="title-primary">パスワード再発行</h2>
                        <h3
                            className="title-primary"
                            style={{ fontSize: '24px', fontWeight: '500', marginTop: '4px', lineHeight: 'inherit' }}>{
                                location?.state?.loginType === LOGIN_TYPE.GROUP_ADMIN ? '（法人管理者向け）' : '（受講者向け）'
                            }</h3>
                        <p className="note-3 mt-4">
                            登録メールアドレスを入力してください。
                            <p className="note-3">お忘れの場合、<a className='hover-link' style={{ color:'#0077B6' }} onClick={navigateInquire}>こちら</a>
                                のフォームよりお問い合わせください。
                            </p>
                        </p>
                        <form onSubmit={handleSubmit(handleForgetPassword)}>
                            <input
                                {...register('email')}
                                id="email"
                                type={'text'}
                                placeholder="メールアドレスを入力してください..."
                            />
                            <button  disabled={isSubmitting} type='button' onClick={handleSubmit(handleForgetPassword)}>
                                <img src="/images/icon10.svg" alt="" />
                            </button>
                        </form>
                        {errors?.email && (
                            <div className="text-danger mg-t-5 fs-error">
                                {errors.email?.message}
                            </div>
                        )}
                        <div className="linklink">
                            <a href={SYSTEM_PATH.LOGIN}>ログイン画面に戻る</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default observer(ForgotPasswordScreen);
